var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex",attrs:{"title":"filter","type":"button"},on:{"click":_vm.onToggleFilter}},[_c('svg-vue',{staticClass:"w-9 h-9 fill-salesium-red",attrs:{"icon":"filter-solid","title":"Filter"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }